/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(window).scroll(function() {
  var windscroll = $(window).scrollTop();  
  $('.tab_cs_content .tab-content').each(function(i) {
    if ($(this).position().top <= windscroll + 50 ) {
      $('.product_tabs li.current').removeClass('current');
      $('.product_tabs li').eq(i).addClass('current');
    }
  }); 
}).scroll(); 
$(document).ready(function(){  
$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

  $('li.tab-link[data-tab="tab-3"]').on('click', function(e) {
        e.preventDefault();
  window.dispatchEvent(new Event('resize'));
});
  
 $(window).scroll(function(){
   var plus = 150
   var divHeigt = $('.product-block-list__wrapper').height();
   var total = divHeigt+plus;
     var scroll = $(window).scrollTop();
     var desPart = $('.product_desciption_custom');
    if (scroll >= total) { desPart.addClass('sticky_part'); }
    else { desPart.removeClass('sticky_part'); }
});

  $(window).scroll(function(){
   var plus = 550
   var scroll = $(window).scrollTop();
   var desPart = $('.product_desciption_custom');
   if (scroll >= plus) { desPart.addClass('sticky_part'); }
   else { desPart.removeClass('sticky_part'); }
});
  
    if (window.outerWidth < 767) {
  $(window).scroll(function(){
     var divone =  $('.product-gallery').height();
     var divtwo =  $('.product-meta').height();
     var plus = 250
       var frequently = $('.cbb-frequently-bought-container').height();
     var all = divone+divtwo+frequently-plus
     var scroll = $(window).scrollTop();
     var desPart = $('.product_desciption_custom');
    if (scroll >= all) { desPart.addClass('sticky_part'); }
    else { desPart.removeClass('sticky_part'); }
});
  };
  
  
  
  });
//   $('#cart_add').click(function(){
//   $('.product-form__add-button').trigger( "click" );
// });
//   $('#now_buy').click(function(){
//   $('.shopify-payment-button__button').trigger( "click" );
// });

$("#now_buy").on('click',function() {
  $(".shopify-payment-button__more-options").click()
})